// extracted by mini-css-extract-plugin
module.exports = {"close-goal":"CloseButton_close-goal__2gpRO","text":"CloseButton_text__JAp_a","active":"CloseButton_active__1B-5w"};